import React, { useState } from 'react';
import { Form, Input, Button, Card, notification } from 'antd';
import { useDispatch } from 'react-redux'; // Import useDispatch for dispatching actions
import {changePasswordAction} from '../../store/action/business/ChangepasswordAction';


const ChangePassword = () => {
  const [form] = Form.useForm();
  const [isVerified, setIsVerified] = useState(false); // State to control visibility of new password fields
  const dispatch = useDispatch();

  const handleCurrentPasswordSubmit = async (values) => {
    const myToken = localStorage.getItem('accessToken'); // Retrieve token from local storage
    const formData = {
      token: myToken,
      oldpassword: values.currentPassword, // Pass the current password entered by the user
    };
  
    try {
      const response = await fetch(`https://verse.blaccdot.com/ldsbackend/auth/oldPasswordverify`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });
  
      if (response.ok) {
        const data = await response.json();
        setIsVerified(true); // Enable new password fields
        notification.success({
          message: 'Success',
          description: 'Current password verified successfully!',
        });
        console.log('Verification response:', data);
      } else {
        setIsVerified(false);
        form.setFields([
          {
            name: 'currentPassword',
            errors: ['Current password is incorrect!'],
          },
        ]);
      }
    } catch (error) {
      console.error('Error during password verification:', error);
      notification.error({
        message: 'Error',
        description: 'Failed to verify the current password. Please try again.',
      });
    }
  };

  const validatePasswords = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue('newPassword') === value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error('New Passwords do not match!'));
    },
  });

  const handleChangePassword = (values) => {
    const takeToken = localStorage.getItem('accessToken')
    const payload = {
      token:takeToken,
      password: values.newPassword,
    }
    dispatch(changePasswordAction(payload))
    form.resetFields();
  };



  return (
    <Card title="Change Password" bordered={false} style={{ maxWidth: 400 }}>
      {/* Current Password Form */}
        <Form form={form} name="current-password" layout="vertical"
            autoComplete="off" onFinish={isVerified ? handleChangePassword : handleCurrentPasswordSubmit}>
            {/* Current Password */}
            <Form.Item label="Current Password" name="currentPassword"
              rules={[{ required: true, message: 'Please input your current password!' }]} >
              <Input.Password placeholder="Enter current password" />
            </Form.Item>
    
            {/* Display Submit Button Initially */}
            {!isVerified && (
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  Submit
                </Button>
              </Form.Item>)}
    
            {/* New Password Fields */}

            {isVerified && (
              <>
                {/* New Password */}
                <Form.Item
                  label="New Password"
                  name="newPassword"
                  rules={[
                    { required: true, message: 'Please input your new password!' },
                    { min: 7, message: 'Password must be at least 6 characters!' },
                  ]}>
                  <Input.Password placeholder="Enter new password" />
                </Form.Item>
    
                {/* Confirm Password */}
                <Form.Item label="Confirm Password" name="confirmPassword" dependencies={['newPassword']}
                  rules={[
                    { required: true, message: 'Please confirm your password!' },
                    validatePasswords,
                  ]}>
                  <Input.Password placeholder="Confirm new password" />
                </Form.Item>
    
                {/* Change Password Button */}
                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Change Password
                  </Button>
          
                </Form.Item>
              </>
            )}
          </Form>
    </Card>
  );
};

export default ChangePassword;
